import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { ContainerSearch, TextFieldStyled } from "./style";

interface ILayoutBasePageProps {
  placeholder: string;
  disabled?: boolean;
  changeTextSearch: (novoTexto: string) => void;
}

export const PageSearch = ({
  disabled,
  placeholder,
  changeTextSearch,
}: ILayoutBasePageProps) => {
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    setSearch("");
  }, [placeholder]);

  useEffect(() => {
    changeTextSearch(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <ContainerSearch>
      <TextFieldStyled
        size="small"
        fullWidth
        autoComplete="off"
        value={search}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#5f6368" }} />
            </InputAdornment>
          ),
        }}
      />
    </ContainerSearch>
  );
};
